<template>
  <div>
    <div>
      <div>
        <div>Lat: {{ center.lat }}</div>
        <div>Lat: {{ center.lng }}</div>
        <div>Addr: {{ currentPlace }}</div>
      </div>
      <label>
        <gmap-autocomplete v-model="currentPlace" @place_changed="setPlace" cancelable="true">
        </gmap-autocomplete>
        <button @click="addMarker">Add</button>
      </label>
    </div>
    <gmap-map :center="center" :zoom="18" style="width:100%;  height: 400px;">
      <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" @dragend="updateMaker" @click="center=m.position"></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data () {
    return {
      center: { lat: 3.139003, lng: 101.686855 },
      markers: [],
      places: ['Kuala Lumpur'],
      currentPlace: 'Kuala Lumpur'
    };
  },

  mounted () {
    this.geolocate();
  },

  methods: {
    setPlace (place) {
      this.currentPlace = place;
      this.center.lat = place.geometry.location.lat()
      this.center.lng = place.geometry.location.lng()
    },
    addMarker () {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker })
        this.places.push(this.currentPlace)
        this.center = marker;
        this.currentPlace = null
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    updateMaker: function (event) {
      console.log('updateMaker, ', event.latLng.lat());
      this.markers[0].position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      }
    },
  }
};
</script>